import { OfferMeta } from "@shared/lib/interfaces/car.interface";
import { RouterConfig } from "@shared/lib/routerConfig";
import { RouterSlugs } from "@shared/lib/routerSlugs";

export const getBreadcrumbItemsFromMeta = (meta?: OfferMeta | null) => {
    if (!meta) return [];

    const items = [
        {
            href: RouterConfig.CATALOG_ALL,
            text: "Каталог"
        }
    ];

    const cityAlias = meta.city?.alias || RouterSlugs.SLUG_ALL_CITIES;

    if (meta.city?.alias && meta.city?.name) {
        items.push({
            href: `${RouterConfig.CATALOG}/${cityAlias}/${RouterSlugs.SLUG_FILTERS_END}`,
            text: meta.city.name
        });
    }

    if (meta.brand?.alias && meta.brand?.name) {
        items.push({
            href: `${RouterConfig.CATALOG}/${cityAlias}/${meta.brand.alias}/${RouterSlugs.SLUG_FILTERS_END}`,
            text: meta.brand.name
        });
    }

    return items;
};